import { useEffect, useState } from "react";
import { api } from "@/lib/api";

function makeList(title, endpoint, renderRow) {
  return function ListPage() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
      api.get(endpoint).then((r) => setItems(r.data || [])).catch(() => setItems([])).finally(() => setLoading(false));
    }, []);
    return (
      <div>
        <h1 className="heading-2">{title}</h1>
        {loading ? (
          <p className="mt-6 text-ink-muted">Loading…</p>
        ) : (
          <div className="mt-6 space-y-4">
            {items.map((r) => renderRow(r))}
            {items.length === 0 && <p className="text-ink-muted">Nothing to show yet.</p>}
          </div>
        )}
      </div>
    );
  };
}

export const CMSMessages = makeList(
  "Contact Messages",
  "/cms/messages",
  (m) => (
    <div key={m.id} className="paper-card p-6">
      <p className="text-sm text-ink font-medium">{m.name} — <span className="text-ink-muted">{m.email}</span></p>
      <p className="text-xs text-ink-muted mt-1">{new Date(m.created_at).toLocaleString()}</p>
      <p className="mt-3 eyebrow">{m.subject}</p>
      <p className="mt-2 body-copy">{m.message}</p>
    </div>
  ),
);

export const CMSAsk = makeList(
  "Ask a Question · Submissions",
  "/cms/ask",
  (q) => (
    <div key={q.id} className="paper-card p-6">
      <p className="text-xs text-ink-muted">{q.email || "no email"} · {new Date(q.created_at).toLocaleString()}</p>
      {q.category && <p className="eyebrow mt-2 text-forest">{q.category}</p>}
      <p className="mt-2 body-copy">{q.question}</p>
    </div>
  ),
);

export const CMSCorrections = makeList(
  "Correction Reports",
  "/cms/corrections",
  (r) => (
    <div key={r.id} className="paper-card p-6">
      <p className="text-xs text-ink-muted">{r.reporter_email || "anonymous"} · {new Date(r.created_at).toLocaleString()}</p>
      <p className="mt-2 eyebrow">{r.content_type} · <a href={`/articles/${r.content_slug}`} className="text-forest hover:underline">{r.content_slug}</a></p>
      <p className="mt-2 body-copy">{r.description}</p>
    </div>
  ),
);

export const CMSNewsletter = makeList(
  "Newsletter Subscribers",
  "/cms/newsletter-subscribers",
  (s) => (
    <div key={s.id} className="paper-card p-4 flex items-center justify-between">
      <p className="text-sm text-ink">{s.email}</p>
      <p className="text-xs text-ink-muted">{s.language} · {new Date(s.created_at).toLocaleDateString()}</p>
    </div>
  ),
);
